export default {
  browse: {
    title: "Explorer",
    sections: {
      advancedTools: "Outils avancés",
      freeTools: "Outils gratuits",
    },
    gamesOfPeriod: "Matchs de la {{period}}",
    periods: {
      day: "journée",
      week: "semaine",
    },
    gameCount_one: "{{count}} match",
    gameCount_other: "{{count}} matchs",
  },
};
